import styled, { css } from 'styled-components'
import colors from '../../../configuration/colors'
import { H6, Caption1, Caption5 } from '../../styled/typography/typography'
import PastJourneySvg from '../../../static/images/icons/icon_past-journey.svg'
import FutureJourneySvg from '../../../static/images/icons/icon_future_journey.svg'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import { dividerWidth } from './utils'

export const CourseSectionRow = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 13px;
  border: ${props => props.theme.courseCardBorder};
  border-radius: 20px;
  background-color: ${props =>
    props.theme.style === 'light'
      ? props.isMentor
        ? '#F8F8F8'
        : colors.white
      : props.theme.cardBackground};
`

export const InactiveJourneyIcon = styled.img.attrs(props => ({
  src: props.future ? FutureJourneySvg : PastJourneySvg,
  alt: props.future ? 'Upcoming Journey' : 'Past Journey'
}))`
  height: 14px;
  width: 14px;
  margin-right: 7px;
`

export const CourseSectionTop = styled(FlexAlignCenter)`
  justify-content: space-between;
  width: 100%;
  padding: 11px 15px 9px 19px;
  border-bottom: ${props => props.theme.scheduleBorder};
  border-radius: 20px 20px 0 0;
  //overflow: hidden;
  &:hover {
    background-color: ${props =>
      props.hasGuidanceOrResource ? props.theme.reportHover : 'transparent'};
  }
`

export const ClickableHeader = styled.div`
  width: 100%;
`

export const CourseSectionBottom = styled.div`
  width: 100%;
  padding: 0;
  position: relative;
`

export const Caption5Margins = styled(Caption5)`
  width: max-content;
  ${props =>
    props.left &&
    css`
      margin-left: ${props => props.left};
    `}
  ${props =>
    props.right &&
    css`
      margin-right: ${props => props.right};
    `}
`

export const EmptyDivider = styled.div`
  width: ${props => dividerWidth + (props.noRequired ? 35 : 0)}px;
  height: 1px;
`

export const DateStatusWrapper = styled(FlexAlignCenter)`
  width: max-content;
  margin-left: 40px;
`

const CoreChoiceMarker = styled.div`
  border: 1px ${colors.dove} solid;
  font-size: 10px;
  color: ${colors.dove};
  text-transform: uppercase;
  display: inline-block;
  padding: 3px;
  font-weight: 500;
  letter-spacing: 0.01px;
  line-height: 9px;
  margin-right: 18px;
`

const H6QuestName = styled(H6)`
  padding-bottom: 5px;
  color: ${props => props.theme.caption4color} !important;
`

const CaptionLearnerGoal = styled(Caption1)`
  padding-bottom: 11px;
`

const NewFeedbackNotification = styled(FlexAlignCenter)`
  position: absolute;
  top: -10px;
  right: -10px;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  justify-content: space-around;
  color: ${colors.white};
  background-color: ${colors.notificationRed};
  font-size: 10px;
  font-weight: 400;
  box-sizing: border-box;
`

export {
  CoreChoiceMarker,
  H6QuestName,
  CaptionLearnerGoal,
  NewFeedbackNotification
}
